import { Component, OnInit } from '@angular/core';
import { APIService } from '../../../app/api.service';
import { CommonService } from '../../services/common.service';
import { formatDate, DatePipe } from '@angular/common';

@Component({
  selector: 'app-payment-receipt',
  templateUrl: './payment-receipt.component.html',
  styleUrls: ['./payment-receipt.component.scss']
})
export class PaymentReceiptComponent implements OnInit {

  constructor(private apiService: APIService, private commonService: CommonService) { }
  jarvisData: any = [];
  agencyData: any = [];
  AgencyName: string = ''
  City: string = '';
  State: string = '';
  editDataList: any = [];
  dataTbl: any = [];
  prntHeader: string = '';
  pipe = new DatePipe('en-US');
  now = Date.now();

  data: any = {
    voucherType: '',
    voucherTypeID: '0',
    details: '',
    payerPartyName: '',
    sumAmount: '0',
    voucherDate: this.pipe.transform(this.now, 'dd-MMM-yy'),
}

type = [
  {
      id: 1,
      name: 'Bank Payment'
  },
  {
      id: 2,
      name: 'Bank Receipt'
  },
  {
      id: 3,
      name: 'Cash Payment'
  },
  {
      id: 4,
      name: 'Cash Receipt'
  },
  {
      id: 5,
      name: 'Journal Voucher'
  },
  {
      id: 6,
      name: 'Purchase Voucher'
  },
  {
      id: 7,
      name: 'Sale Voucher'
  },
  {
      id: 8,
      name: 'Contra Entry'
  },
  {
      id: 9,
      name: 'Salary'
  }
]

printPaymentReceipt(){
  setTimeout(function () {
    var printArea = $('#pmtReceipt').html();
    $('body').html(printArea); 
    window.print(); 
});
}


  ngOnInit(): void {

    let agencyData = this.apiService.getCookie("M");
        if (agencyData) {
            this.agencyData = JSON.parse(agencyData);
            this.prntHeader = this.agencyData[0].Letterhead;
        }
        var jarvis = this.apiService.getCookie("Jarvis");
        if (jarvis) {
            this.jarvisData = JSON.parse(jarvis);
        }
        this.getVoucherPrintData();
  }

   //getEditData()
   getVoucherPrintData() {
    this.AgencyName = this.agencyData[0].AgencyName;
    this.City = this.agencyData[0].City;
    this.State = this.agencyData[0].State;
    
    var tempData = [{
        'voucherID': this.commonService.GetParam('VID')
    }]
    let myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        myLastSyncDT: null,
        isWeb: true,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        actionType: 'initEdit',
        moduleID: 0,
        data: JSON.stringify(tempData)
    }];
    this.apiService.getData(myParams, this.successEditResp.bind(this), this.failureResp.bind(this));

}

//successResp - success  get handler
successEditResp(res: any) {
    if (res.error) {
    }
    else {
        if (res) {
            var reponseData = JSON.parse(res.updatePackage);
            if (reponseData.Table1[0]) {
                let editDataArry = reponseData.Table1;
                this.editDataList = editDataArry;
                this.dataTbl = [];
                for (let i = 0; i < this.editDataList.length; i++) {
                    this.data.voucherDate = new Date(this.editDataList[i].EffectiveDate).customFormat("#DD#-#MMM#-#YY#");
                    this.data.payerPartyName = this.editDataList[i].PayerPartyName;
                    this.data.sumAmount =  Number(this.data.sumAmount) + Number(this.editDataList[i].CreditAmount);
                    this.data.voucherTypeID = this.editDataList[i].VoucherTypeID;
                    let tmpVchrId = this.data.voucherTypeID;
                    if(tmpVchrId == '2' || tmpVchrId == '4'){
                      let tmpVoucherName = this.type.filter(function (element: any, index: any) {
                        return (element.id == tmpVchrId);
                      });
                      this.data.voucherType = tmpVoucherName[0].name;
                    }
                    else{
                      window.close();
                    }
                  this.data.details = this.editDataList[i].MainNotes;
                }
                this.printPaymentReceipt();
            }
        }
    }
}


//failureResp - failure handler
failureResp(res: any) {
    if (res.error) {
    }
    else {
        alert(res.message);
    }
}

}
